import { Component, OnInit } from '@angular/core';
import { CodaltComponent } from 'src/app/codalt.component';

@Component({
    selector: 'app-settlement-send-all',
    templateUrl: './settlement-send-all.component.html',
    styleUrls: ['./settlement-send-all.component.scss'],
    standalone: false,
})
export class SettlementSendAllComponent extends CodaltComponent implements OnInit {
    endDate: Date;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.endDate = new Date();
    }
}
